import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleText"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H15.2858L11.9951 21.7263L8.74274 19H3V3ZM8 8.25V9.75H16V8.25H8ZM8 12.25V13.75H16V12.25H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleText;
